module.exports = __webpack_public_path__ + "img/solution11.d37af3db.png";